import {
  Calendar, PackageCheck, AlertTriangle, Truck 
} from 'lucide-react';
import type { DeliveryStatus } from '@/features/receiving';

export const DEFAULT_SITE_ID = 'site-celebration';

export const TABS = [
  {
    id: 'expected',
    label: 'Expected Deliveries',
    href: '/receiving/expected',
    icon: Calendar,
  },
  {
    id: 'goods',
    label: 'Receive Goods',
    href: '/receiving/goods',
    icon: PackageCheck,
  },
  {
    id: 'discrepancies',
    label: 'Discrepancies',
    href: '/receiving/discrepancies',
    icon: AlertTriangle,
  },
] as const;

export const STATUS_TABS: {
  value: DeliveryStatus | undefined;
  label: string 
}[] = [
  {
    value: undefined,
    label: 'All' 
  },
  {
    value: 'scheduled',
    label: 'Scheduled' 
  },
  {
    value: 'in-progress',
    label: 'In Progress' 
  },
  {
    value: 'completed',
    label: 'Completed' 
  },
  {
    value: 'partial',
    label: 'Partial' 
  },
];

export type TabId = 'expected' | 'goods' | 'discrepancies';

export const STAT_ICONS = {
  total: Truck,
  scheduled: Calendar,
  inProgress: PackageCheck,
  completed: AlertTriangle,
} as const;
